import { useState } from "react";
import { DeleteSales } from "../../../api/Sales/DeleteSales";
import { toast } from "react-toastify";
import TrashIcon from "../../Icons/TrashIcon";
import DeleteModal from "../../Shared/DeleteModal";
const SalesMemberCard = ({ salesId, img, name, email }: { img?: string; name?: string; email?: string; salesId: string; }) => {

    const handleDelete = async (id:string) => {
        await DeleteSales(id);
        toast.success("Sales account deleted successfully");
    };
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="relative flex h-[289px] flex-col items-center justify-center rounded-2xl border border-black/10 bg-white p-8 text-center shadow-sm transition duration-300 hover:-translate-y-0.5 hover:shadow-[0_22px_55px_rgba(17,24,22,0.12)]">
            <img src={img} className="mb-6 size-[110px] rounded-2xl border border-black/10 object-cover object-[75%_25%] shadow-sm" alt="" />
            <h1 className="mb-1 font-bold text-textPrimary">{name}</h1>
            <p className="text-xs text-lightGray">{email}</p>
            <button onClick={() => setIsOpen(true)} className="absolute right-3 top-3 grid size-9 place-items-center rounded-xl text-red-600 transition hover:bg-red-50"><TrashIcon /></button>
            <DeleteModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                mutationFn={handleDelete}
                itemId={salesId}
                queryKey="sales"
            />

        </div>
    )
}

export default SalesMemberCard
